import React from 'react'
import LazyLoad from 'react-lazyload'
import { DesignRow } from 'components/design'
import { Rimg } from 'components/images'

export default function VerticalImagePair({
	className,
	descriptorPair,
	imagePair: [leftImage, rightImage],
	wrapperPair,
}) {
	const [leftWrapper, rightWrapper] = wrapperPair || []
	const [leftDescriptor, rightDescriptor] = descriptorPair || []

	const Image = ({ image, imgClassName }) => (
		<LazyLoad once height={700} offset={400} className={imgClassName || ''}>
			<Rimg image={image} position="verticalImage" alt={image?.alt || ''} />
		</LazyLoad>
	)

	const leftContents = leftWrapper ? (
		leftWrapper({
			children: <Image image={leftImage} />,
			addTopMargin: Boolean(rightImage),
		})
	) : (
		<Image
			image={leftImage}
			imgClassName={rightImage ? 'mt-0 md:mt-20 xl:mt-30' : ''}
		/>
	)

	const rightContents = rightImage ? (
		rightWrapper ? (
			rightWrapper({ children: <Image image={rightImage} /> })
		) : (
			<Image image={rightImage} />
		)
	) : null

	return (
		<DesignRow
			className={`${className || 'my-16'}`}
			leftImage={
				<>
					{leftContents}
					{leftDescriptor}
				</>
			}
			rightImage={
				rightContents ? (
					<>
						{rightContents}
						{rightDescriptor}
					</>
				) : null
			}
		/>
	)
}
